import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=3a957dec&scoped=true"
import script from "./FaqCard.vue?vue&type=script&lang=js"
export * from "./FaqCard.vue?vue&type=script&lang=js"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=3a957dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a957dec",
  null
  
)

export default component.exports